import React, { createContext, useState } from 'react';

const UserContext = createContext();

const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    accountType : ""
  });

  // Function to set the user data (e.g., after successful sign-in)
  const handleSignIn = (userData) => {
    setUser(userData);
  };

  // Function to clear user data (e.g., after sign-out)
  const handleSignOut = () => {
    setUser(null);
    localStorage.removeItem('tokenKey');
    localStorage.removeItem('domain');
    localStorage.removeItem('acctDbKey');
    localStorage.removeItem('pusherTransportTLS');
    localStorage.removeItem('company');
    localStorage.removeItem('companyKey');
    localStorage.removeItem('refreshToken');
  };

  // Value to be provided to consuming components
  const contextValue = {
    user,
    signIn: handleSignIn,
    signOut: handleSignOut,
  };

  return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>;
};

export { UserContext, UserProvider };
